import Header from "./header";

const HeaderModel = () => {
  return <Header />;
};

export default HeaderModel;
